/* Muscle IQ universal product page: option chips → variant, price, stock / pre-order, gallery, quantity,
   AJAX add to cart. Without JavaScript the plain Shopify product form still works (first variant). */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* stock state -> delivery box colour and stock badges (data-state in / pre / out; labels in data-l-*) */
  function paintStock(root, state) {
    $$('[data-stock-box], [data-stock-badge]', root).forEach(function (el) {
      el.setAttribute('data-state', state);
      var tx = el.querySelector('[data-stock-text]'), l = el.getAttribute('data-l-' + state);
      if (tx && l) tx.textContent = l;
    });
  }

  function init(root) {
    if (!root || root._pd) return; root._pd = true;
    var jsonEl = $('[data-pd-json]', root.parentNode) || $('[data-pd-json]');
    if (!jsonEl) return;
    var data; try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var variants = data.variants || [], S = data.strings || {};
    var form = $('[data-pd-form]', root), idInput = $('[data-pd-id]', root), qtyInput = $('[data-pd-qty-input]', root);
    var groups = $$('[data-pd-opt]', root), err = $('[data-pd-error]', root);
    var money = function (c) { return (window.MIQ && MIQ.money) ? MIQ.money(c) : '£' + (c / 100).toFixed(2); };
    var params = new URLSearchParams(location.search);
    var current = variants.filter(function (v) { return String(v.id) === String(idInput && idInput.value); })[0] || variants[0];
    if (params.get('variant')) { var fromUrl = variants.filter(function (v) { return String(v.id) === params.get('variant'); })[0]; if (fromUrl) current = fromUrl; }
    var qty = 1;
    /* "Complete your setup": ticked add-ons are added with the product, one of each */
    var addons = $$('[data-pd-addon]', root);
    function picked() { return addons.filter(function (b) { return b.getAttribute('aria-pressed') === 'true' && !b.disabled; }); }
    function total(v) { return v.price * qty + picked().reduce(function (a, b) { return a + (+b.dataset.price || 0); }, 0); }

    function selected() { return groups.map(function (g) { var b = $('button[aria-pressed="true"]', g); return b ? b.dataset.pdValue : null; }); }
    function find(opts) { return variants.filter(function (v) { return opts.every(function (o, k) { return o === null || v.options[k] === o; }); })[0]; }

    /* option names in the admin sometimes carry an old price, e.g. "Dumbbell Stand (+£86.00)"; show the name only */
    var PRICE_IN_NAME = /\s*(\(\s*\+?\s*£?\s*\d[\d.,]*\s*\)|\+\s*£\s*\d[\d.,]*)\s*$/;
    function clean(t) { return String(t || '').replace(PRICE_IN_NAME, ''); }
    /* the extra cost of each chip, worked out from the real variant prices with the other options as chosen:
       price(this value) minus price(the first value in the group, e.g. "No stand") */
    function deltas(sel) {
      groups.forEach(function (g, k) {
        var btns = $$('button[data-pd-value]', g); if (!btns.length) return;
        var baseSel = sel.slice(); baseSel[k] = btns[0].dataset.pdValue;
        var base = find(baseSel);
        btns.forEach(function (b, i) {
          var el = $('[data-pd-delta]', b); if (!el) return;
          var t = sel.slice(); t[k] = b.dataset.pdValue; var v = find(t);
          var d = (i > 0 && v && base) ? v.price - base.price : 0;
          el.textContent = d > 0 ? '+' + money(d) : d < 0 ? '\u2212' + money(-d) : '';
        });
      });
    }
    function markChips() {
      /* a chip is crossed out when no available variant has it together with the other chosen options */
      var sel = selected();
      groups.forEach(function (g, k) {
        $$('button[data-pd-value]', g).forEach(function (b) {
          var test = sel.slice(); test[k] = b.dataset.pdValue;
          var ok = variants.some(function (v) { return v.available && test.every(function (o, j) { return o === null || v.options[j] === o; }); });
          b.classList.toggle('is-off', !ok);
          b.setAttribute('aria-pressed', b.dataset.pdValue === sel[k] ? 'true' : 'false');
        });
        var lab = $('[data-pd-label]', g); if (lab) lab.textContent = clean(sel[k] || '');
      });
      deltas(sel);
    }

    function setAll(sel, html) { $$(sel).forEach(function (el) { el.innerHTML = html; }); }
    function render(v, fromClick) {
      var ok = !!v, avail = ok && v.available;
      var pre = ok && (v.pre_order === true || data.preTag === true);
      if (idInput) idInput.value = ok ? v.id : '';
      /* tell Shopify's payment message and app blocks that the variant changed */
      if (idInput && fromClick) idInput.dispatchEvent(new Event('change', { bubbles: true }));
      if (ok) $$('shopify-payment-terms').forEach(function (el) { el.setAttribute('variant-id', v.id); });
      if (ok && fromClick) {
        var kl = $$('[data-pd-klarna]');
        if (kl.length) {
          kl.forEach(function (el) { el.setAttribute('data-purchase-amount', v.price); });
          try { if (window.Klarna && Klarna.OnsiteMessaging && Klarna.OnsiteMessaging.refresh) Klarna.OnsiteMessaging.refresh(); } catch (e) {}
          try { (window.KlarnaOnsiteService = window.KlarnaOnsiteService || []).push({ eventName: 'refresh-placements' }); } catch (e) {}
        }
      }
      if (ok) {
        setAll('[data-pd-price]', money(v.price));
        var off = v.compare > v.price;
        $$('[data-pd-was]').forEach(function (el) { el.hidden = !off; });
        setAll('[data-pd-compare]', off ? money(v.compare) : '');
        $$('[data-pd-off], [data-pd-badge]').forEach(function (el) { el.hidden = !off; el.textContent = off ? money(v.compare - v.price) + ' ' + (S.off || 'off') : ''; });
        setAll('[data-pd-total]', money(total(v)));
        $$('[data-pd-variant-title]').forEach(function (el) { el.textContent = groups.length ? v.options.map(clean).join(' / ') : ''; });
      }
      $$('[data-pd-add]').forEach(function (b) { b.disabled = !avail; });
      var lab = $('[data-pd-add-label]', root);
      if (lab) lab.innerHTML = !ok ? (S.unavailable || 'Unavailable') : avail ? (ok && v.pre_order === true ? (S.preOrder || 'Pre-order now') : (S.add || 'Add to cart')) + ' · <span data-pd-total>' + money(total(v)) + '</span>' : (S.soldOut || 'Sold out');
      $$('[data-pd-add-short]').forEach(function (el) { el.textContent = ok && v.pre_order === true ? (S.preOrder || 'Pre-order now') : (S.add || 'Add to cart'); });
      $$('[data-pd-stock]', root).forEach(function (el) { el.hidden = pre || !avail; });
      $$('[data-pd-pre]', root).forEach(function (el) { el.hidden = !pre || !avail; });
      $$('[data-pd-out]', root).forEach(function (el) { el.hidden = avail; });
      paintStock(root, !avail ? 'out' : (pre || data.preAll === true) ? 'pre' : 'in');
      if (err) err.hidden = true;
      if (ok && fromClick) {
        if (v.media) { var g = $('[data-gallery]'); if (g && g._api) g._api.showMedia(v.media); }
        try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u); } catch (e) {}
      }
    }

    groups.forEach(function (g, k) {
      g.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-pd-value]'); if (!b) return;
        $$('button[data-pd-value]', g).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        var sel = selected(), v = find(sel);
        if (!v || !v.available) {
          /* keep the clicked value and pick the closest available variant for the other options */
          var alt = variants.filter(function (x) { return x.available && x.options[k] === b.dataset.pdValue; })[0] || variants.filter(function (x) { return x.options[k] === b.dataset.pdValue; })[0];
          if (alt && (!v || alt.available)) { v = alt; groups.forEach(function (gg, j) { $$('button[data-pd-value]', gg).forEach(function (x) { x.setAttribute('aria-pressed', x.dataset.pdValue === v.options[j] ? 'true' : 'false'); }); }); }
        }
        current = v; markChips(); render(v, true);
      });
    });

    addons.forEach(function (b) { b.addEventListener('click', function () {
      b.setAttribute('aria-pressed', b.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
      if (current) setAll('[data-pd-total]', money(total(current)));
    }); });
    var q = $('[data-pd-qty]', root);
    if (q) q.addEventListener('click', function (e) {
      var b = e.target.closest('[data-d]'); if (!b) return;
      qty = Math.max(1, Math.min(99, qty + (+b.dataset.d)));
      $('output', q).textContent = qty; if (qtyInput) qtyInput.value = qty;
      if (current) setAll('[data-pd-total]', money(total(current)));
    });

    function add(btn) {
      if (!current || !current.available) return;
      if (!(window.MIQ && MIQ.cart)) { form.submit(); return; }
      var pre = current.pre_order === true || data.preTag === true;
      var btns = $$('[data-pd-add]'); btns.forEach(function (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
      MIQ.cart.add([{ id: current.id, quantity: qty, properties: pre ? { _pre_order: 'Yes' } : {} }].concat(picked().map(function (b) { return { id: +b.dataset.pdAddon, quantity: 1 }; })))
        .then(function () { MIQ.openDrawer && MIQ.openDrawer('cartDrawer'); })
        .catch(function (e) { if (err) { err.textContent = e.message; err.hidden = false; } })
        .then(function () { btns.forEach(function (b) { b.disabled = !current.available; b.removeAttribute('aria-busy'); }); });
    }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); add(); });
    $$('[data-pd-add]').forEach(function (b) { if (b.type !== 'submit') b.addEventListener('click', function () { add(b); }); });

    if (groups.length && current) {
      groups.forEach(function (g, j) { $$('button[data-pd-value]', g).forEach(function (x) { x.setAttribute('aria-pressed', x.dataset.pdValue === current.options[j] ? 'true' : 'false'); }); });
      markChips();
    }
    if (current) render(current, false);
  }

  /* ---------- thumbnail row: arrows appear when there are more thumbnails than fit ---------- */
  function initThumbs(box) {
    if (box._th) return; box._th = true;
    var row = $('[data-g-thumbs], [data-pd-addon-row]', box), navs = $$('[data-th], [data-ad]', box); if (!row) return;
    navs.forEach(function (b) { if (!b.dataset.th) b.dataset.th = b.dataset.ad; });
    function upd() {
      var more = row.scrollWidth > row.clientWidth + 2;
      navs.forEach(function (b) { b.hidden = !more; b.disabled = +b.dataset.th < 0 ? row.scrollLeft < 4 : row.scrollLeft > row.scrollWidth - row.clientWidth - 4; });
    }
    navs.forEach(function (b) { b.addEventListener('click', function () { row.scrollBy({ left: +b.dataset.th * row.clientWidth * 0.8, behavior: 'smooth' }); }); });
    row.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
  }

  /* ---------- image pop-up: tap the big image, then swipe / arrows / keyboard ---------- */
  function initZoom(g) {
    if (g._zoom) return; g._zoom = true;
    var track = $('[data-g-track]', g); if (!track) return;
    var slides = $$('.g-slide', track).filter(function (s) { return $('img', s); });
    if (!slides.length) return;
    var dlg, ztrack, count, n = 0;
    function big(img) { var src = (img.currentSrc || img.src).replace(/([?&])width=\d+/, '$1width=2000'); return src; }
    function build() {
      dlg = document.createElement('dialog'); dlg.className = 'pd-lb'; dlg.setAttribute('aria-label', g.dataset.zoomLabel || 'Images');
      dlg.innerHTML = '<div class="pd-lb-top"><span class="pd-lb-count mono" aria-live="polite"></span><button type="button" class="pd-lb-x" data-lb-close aria-label="' + (g.dataset.closeLabel || 'Close') + '"><svg aria-hidden="true"><use href="#i-x"/></svg></button></div>' +
        '<div class="pd-lb-track" tabindex="0">' + slides.map(function (s) { var im = $('img', s); return '<figure><img data-src="' + big(im) + '" alt="' + (im.alt || '').replace(/"/g, '&quot;') + '"></figure>'; }).join('') + '</div>' +
        (slides.length > 1 ? '<button type="button" class="g-nav prev" data-lb="-1" aria-label="' + (g.dataset.prevLabel || 'Previous') + '"><svg><use href="#i-left"/></svg></button><button type="button" class="g-nav next" data-lb="1" aria-label="' + (g.dataset.nextLabel || 'Next') + '"><svg><use href="#i-right"/></svg></button>' : '');
      document.body.appendChild(dlg);
      ztrack = $('.pd-lb-track', dlg); count = $('.pd-lb-count', dlg);
      dlg.addEventListener('click', function (e) {
        var b = e.target.closest('[data-lb]'); if (b) { go(n + (+b.dataset.lb)); return; }
        if (e.target.closest('[data-lb-close]') || e.target === dlg || e.target.tagName === 'FIGURE') dlg.close();
      });
      dlg.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { e.preventDefault(); go(n + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); go(n - 1); } });
      ztrack.addEventListener('scroll', function () { var k = Math.round(ztrack.scrollLeft / Math.max(1, ztrack.clientWidth)); if (k !== n) { n = k; mark(); } }, { passive: true });
      dlg.addEventListener('close', function () { document.documentElement.classList.remove('pd-lb-open'); if (g._api) g._api.show(n, true); });
    }
    function load(k) { [k - 1, k, k + 1].forEach(function (j) { var im = $$('img', ztrack)[j]; if (im && !im.src) im.src = im.dataset.src; }); }
    function mark() { load(n); if (count) count.textContent = (n + 1) + ' / ' + slides.length; $$('[data-lb]', dlg).forEach(function (b) { b.disabled = +b.dataset.lb < 0 ? n === 0 : n === slides.length - 1; }); }
    function go(k, instant) { n = Math.max(0, Math.min(slides.length - 1, k)); ztrack.scrollTo({ left: n * ztrack.clientWidth, behavior: instant ? 'auto' : 'smooth' }); mark(); }
    function open(k) {
      if (!dlg) build();
      if (typeof dlg.showModal !== 'function') return;
      document.documentElement.classList.add('pd-lb-open'); dlg.showModal(); go(k, true); ztrack.focus();
    }
    /* a tap opens the viewer; a swipe (the image row moved) does not */
    var downX = 0, downLeft = 0;
    track.addEventListener('pointerdown', function (e) { downX = e.clientX; downLeft = track.scrollLeft; });
    track.addEventListener('click', function (e) {
      var s = e.target.closest('.g-slide'); if (!s || Math.abs(e.clientX - downX) > 8 || Math.abs(track.scrollLeft - downLeft) > 8) return;
      var k = slides.indexOf(s); if (k > -1) open(k);
    });
    track.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); open(g._api && g._api.index ? g._api.index() : 0); } });
  }

  function boot(scope) {
    $$('[data-pd-thumbs], [data-pd-addon-wrap]', scope).forEach(initThumbs);
    $$('[data-pd-zoom]', scope).forEach(initZoom); $$('[data-pdp]', scope).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); }); else boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

